import { KYMW0900Model } from '../kymw0900.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { NextGuideRequestModel } from '../vo/kymw0900-next-guide-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 次回案内取得サービス
 *
 * @export GetNextGuideService
 * @class GetNextGuideService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNextGuideService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {NextGuideRequestModel}
   * @memberof GetNextGuideService
   */
  private vo: NextGuideRequestModel = null;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetNextGuideService
   */
  private model: KYMW0900Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetNextGuideService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetNextGuideService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          parameter: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetNextGuideService
   */
  execute(model: any, vo: NextGuideRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getNextGuide', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNextGuideService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.updateNextGuideList(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
